import BookingProjectSettings from '../../types/model/BookingProjectSettings';

export const defaultProjectSettings: BookingProjectSettings = {
  id: 0,
  bookingProjectSettings: {
    operatingHoursFrom: '06:00:00',
    operatingHoursTo: '17:00:00',
    deliveryDurationMin: 0.5,
    deliveryDurationMax: 8,
    documentName: '',
    documentFullName: '',
    bookingDeadline: 100,
    automaticConfirmationTime: 168,
    isInBarrierSystem: false
  },
  bookingProjectEquipment: [],
  projectDeliveryZones: []
};
